import {
  PERFORM_LOGIN,
} from './action-types';
export * from './toast'
import { Whoami as UserWhoami } from '../api/types';
export {
  ADD_LOADING, DEL_LOADING, RESET_TENTATIVO, NUOVO_TENTATIVO,
  del_loading, add_loading, add_tentativo_action, reset_tentativo_action,
  loadingAction, TentativoAction,
} from 'django-rest-react'


export interface performLoginAction {
  type: typeof PERFORM_LOGIN,
  user: UserWhoami
}

export function set_user_data(user: UserWhoami): performLoginAction {
  return { type: PERFORM_LOGIN, user: user };
}
